import React, { useState } from 'react'
import { Field, Label, Radio, RadioGroup } from '@headlessui/react'

const RadioGroupList = ({options, defaultSelected = 0, radioButtonClassName = undefined, ariaLabel = '', ...props}) => {
  const [selected, setSelected] = useState(defaultSelected >= 0 ? options[defaultSelected] : '')

  const handleRadioChange = (item) => {
    setSelected(item)
    if(props.onChange) {
      props.onChange(item)
    }
  }

  return (
    <React.Fragment>
      <div>
        <RadioGroup
          value={selected}
          className={`${props.className}`}
          onChange={(item) => handleRadioChange(item)}
          aria-label={ariaLabel}
        >
          {options.map((option) => {
            return (
              <Field
                key={option.id}
                className={`${
                  radioButtonClassName ?? "flex items-center gap-3"
                }`}
              >
                <Radio
                  value={option}
                  className={`group flex size-4 items-center justify-center rounded-full border border-gray-400 bg-white data-[checked]:bg-white`}
                  aria-label={`${ariaLabel}-${option}`}
                >
                  <span
                    className={`invisible size-3 rounded-full bg-black group-data-[checked]:visible`}
                  />
                </Radio>
                <Label>{option.label}</Label>
              </Field>
            );
          })}
        </RadioGroup>
      </div>
    </React.Fragment>
  );
}

export default RadioGroupList